var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');
require('flickity-imagesloaded');
import LazyLoad from 'vanilla-lazyload';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );

jQueryBridget( 'flickity', Flickity, $ );
jQueryBridget( 'lazy', LazyLoad, $ );
// now you can use $().flickity()

export default {
  init() {
    // Debug WooCommerce initialization
    console.log('WC Cart Fragments Params:', window.wc_cart_fragments_params);
    console.log('WC Add to Cart Params:', window.wc_add_to_cart_params);
    
    // Check if fragments are enabled
    if (typeof wc_cart_fragments_params === 'undefined') {
      console.warn('WooCommerce cart fragments not initialized!');
    }

    // EVENTS

    $('.hamburger').on('click', function(event) {
      event.preventDefault();
      $(this).toggleClass('is-active');
      $('.nav-full').toggleClass('opened_section');
    })

    // make entire meta box clickable (unless click is on a link, in which case, follow the link)
    $(document).on('click', 'article.featured_content, .meta', function(event){
      if (event.target.nodeName !== 'A') window.location.href = $(this).data('url');
    });


    // Load the gallery of the single-item when clicking
    $('a[role=ajax_load_gallery]').on('click', function(e){ // add , .ajax-item .meta to the selector to activate ajax for archive
      e.preventDefault();
      e.stopPropagation();
        // create layer to display content on top of the page
        var target = $('<div>')
          .attr({'class':'bw_box'})
          .appendTo('body');
        var load_url = '';
        if (!$(this).attr('href') ) {
           load_url = $(this).data('url') + ' div.entry-content';
        } else {
           load_url = $(this).attr('href') + ' div.entry-content';
        }

        var submit_data = {};
        target.load(
          load_url,
          submit_data,
          function() {
            $('.bw_box .images_gallery').find('img').each(function() {
              var $t = $(this);
              $t.attr({
                  'data-flickity-lazyload-srcset': $t.data('srcset'),
                })
                .removeAttr('data-srcset')
                .attr({
                  'data-flickity-lazyload-src': $t.data('src'),
                })
                .removeAttr('data-src')
                .removeClass('lazy');
            });
            $('.bw_box').addClass('active');
            $('.bw_box .images_gallery').flickity({
              pageDots: false,
              fullscreen: false,
              cellSelector: 'figure',
              prevNextButtons: true,
              wrapAround: true,
              imagesLoaded: false,
              lazyLoad: 3,
              autoPlay: false,
              arrowShape: 'M84.3,0l-70,50l70,50',
            });
            $('<div>')
            .attr({'class':'bw_box_close_button'})
              .appendTo('.bw_box .entry-content .container');
            $('<button>')
              .attr({'class':'close'})
              .appendTo('div.bw_box_close_button');
            $('.bw_box_close_button').addClass('active');
          }
        );
    })

    // Load the image in big window
    $('a[role=popup_photo]').on('click', function(e){ // add , .ajax-item .meta to the selector to activate ajax for archive
      e.preventDefault();
      e.stopPropagation();
        // create layer to display content on top of the page
        $('<div>')
          .attr({'class':'bw_box'})
          .appendTo('body');
        var load_url = '';
        load_url = $(this).attr('href');
        var target = $('<div>')
          .attr({'class':'bw_box--inner'})
          .appendTo($('.bw_box'));
        $('<img>')
          .attr({'src':load_url})
          .appendTo(target);

        $('.bw_box').addClass('active');

        $('<div>')
        .attr({'class':'bw_box_close_button'})
          .appendTo('.bw_box');
        $('<button>')
          .attr({'class':'close'})
          .appendTo('div.bw_box_close_button');
        $('.bw_box_close_button').addClass('active');

    });


    // Add to cart on page (already, at load time)
    $('body').on('click', 'a.add_to_cart_button', add_to_cart );

    $('body').on('click', '.bw_box_close_button button', function() {
      $('div.bw_box').remove();
      $('div.bw_box_close_button').remove();
    });

    $('body:not(.woocommerce-cart,.woocommerce-checkout)').on('updated_wc_div', function() {
      $('.cart_contents_container').addClass('opened');
      setTimeout(function(){ $('.cart_contents_container').removeClass('opened'); }, 3000);
    });

    // ADD FLICKITY SLIDER IF PRESENT ON PAGE

    if ( $('.container-featured_slider').length > 0 ) {


      var $carousel = $('.container-featured_slider');

      $carousel.find('img').each(function() {
        var $t = $(this);
        $t.attr({
            'data-flickity-lazyload-srcset': $t.data('srcset'),
          })
          .removeAttr('data-srcset')
          .attr({
            'data-flickity-lazyload-src': $t.data('src'),
          })
          .removeAttr('data-src')
          .removeClass('lazy');
      });

      $carousel.flickity({
        pageDots: false,
        fullscreen: false,
        cellSelector: 'article',
        prevNextButtons: false,
        wrapAround: true,
        imagesLoaded: false,
        autoPlay: true,
        lazyLoad: 7,
        fade: true,
      });

      var $carouselNav = $('.nav-slideshow ul');
      $carouselNav.on( 'mouseenter', 'li', function() {
        event.stopPropagation();
        var index = $(this).index();
        $carousel.flickity( 'select', index );
        $carousel.flickity( 'stopPlayer' );
      });

      $carouselNav.on( 'mouseleave', 'li', function() {
        $carousel.flickity( 'playPlayer' );
      });


      var $carouselButtons = $carouselNav.find('li');

      var flkty = $carousel.data('flickity');

      $carouselButtons.first().addClass('its-on');

      $carousel.on( 'select.flickity', function() {
        $carouselButtons.filter('.its-on')
          .removeClass('its-on');
        $carouselButtons.eq( flkty.selectedIndex )
          .addClass('its-on');
      });
    }

    // Add this at the top level of your common.js to catch all fragment refresh requests
    $(document.body).on('wc_fragment_refresh', function() {
      console.log('WC Fragment refresh triggered');
    });

    $(document.body).on('wc_fragments_loaded', function() {
      console.log('WC Fragments loaded');
    });

    $(document.body).on('wc_fragments_ajax_error', function() {
      console.log('WC Fragments ajax error');
    });

    function add_to_cart(e) {
      e.preventDefault();
      
      var add_to_cart_url = $(e.target).attr('href');
      if (add_to_cart_url.startsWith('//')) {
        add_to_cart_url = window.location.protocol + add_to_cart_url;
      }
      
      // Add variation ID if present
      if ($('select#variation_id').length) {
        add_to_cart_url += '&variation_id=' + $('select#variation_id').children('option:selected').val();
      }

      $.ajax({
        url: add_to_cart_url,
        type: 'POST',
        data: {
          'add-to-cart': $(e.target).data('product_id'),
        },
        success: function() {
          // Show cart dropdown
          $('.cart_contents_container').addClass('opened');
          
          // Since we have wc_add_to_cart_params but not fragments, use WC's AJAX endpoint
          if (typeof window.wc_add_to_cart_params !== 'undefined') {
            $.ajax({
              url: window.wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments'),
              type: 'POST',
              data: {
                time: new Date().getTime(),
              },
              success: function(data) {
                if (data && data.fragments) {
                  $.each(data.fragments, function(key, value) {
                    $(key).replaceWith(value);
                  });
                }
              },
            });
          } else {
            // Fallback: reload cart content directly
            $.get(window.location.origin + '/cart/', function(data) {
              var newCartHtml = $(data).find('.header-quickcart').html();
              $('.header-quickcart').html(newCartHtml);
            });
          }

          // Hide cart after delay
          setTimeout(function() {
            $('.cart_contents_container').removeClass('opened');
          }, 2000);
        },
        error: function(xhr, status, error) {
          console.error('Add to cart error:', error);
          console.error('Status:', status);
          console.error('Response:', xhr.responseText);
        },
      });
    }
    // Catalogue on the page?
    if ( $('.filtered').length > 0 ) {
      // data collection!
      var items_data = [];
      $('.single_item').each(function(){
        var id = $(this).data('item_id');
        var data = '|'+$(this).data('item_creator')+'|';
        data += $(this).data('item_title')+'|';
        data += $(this).data('item_commission')+'|';
        data += $(this).data('item_designer')+'|';
        data = data.toLowerCase();
        items_data.push({id, data});
      });
    }

    // behaviours: type text in the filter
    if ( $('.filtered').length > 0 ) {

      // generate the text box
      var filter_container = $('<div>')
        .addClass('filter_container')
        .appendTo('body');
      $('<div>')
        .addClass('proposing_terms_completion')
        .appendTo(filter_container);
      $('<input>')
        .addClass('catalogue_filter')
        .attr('placeholder', 'Filter: artist, year, commission, designer etc')
        .on('keyup', function(e){
            // empty the proposed terms
            $('.proposed_term').remove();
            //
            var hay = $(this).val().toLowerCase();
            var proposed_terms = [];
            let matched_results = items_data.map(item => {
              var matching_string_position = item.data.indexOf(hay);
              if (matching_string_position > -1) {
                // take from the beginning of the string until the position; get the lastIndexOf |
                var start_string = item.data.substring(0,matching_string_position);
                var end_string = item.data.substring(matching_string_position, item.data.length);
                var match_string_start = start_string.lastIndexOf('|')+1;
                var match_string_end = start_string.length+end_string.indexOf('|');
                var matching_string = item.data.substring(match_string_start, match_string_end);
                // take the string from the matched position until the end
                // var updated_item = {matching_string_position: matching_string_position, matching_string: matching_string, data: item.data, id: item.id }

                if ( proposed_terms.indexOf(matching_string) === -1) {
                  proposed_terms.push(matching_string);
                  $('.proposing_terms_completion').append(
                    $('<div>')
                    .addClass('proposed_term')
                    .text(matching_string)
                    .on('click', function() {
                      $('.catalogue_filter')
                        .val( $(this).text() )
                        .trigger('keyup');
                      $('.proposed_term').remove();
                    })
                  );
                }

                return item;
            }});
            matched_results = matched_results.filter(function( item ) {
               return item !== undefined;
            });
            if (matched_results.length > 0) {
              // hide all the non matching element
              $('.single_item').addClass('filter_hide_product');

              matched_results.forEach(item => {
                // item is the referenec to the elements contained in the results array
                // we will get the data from the DOM by translating the reference into a real element on the page
                var item_id = item.id;
                var item_element = $('[data-item_id='+item_id+']');
                item_element
                  .removeClass('filter_hide_product')
                  .removeClass('not_in_view')
                  .addClass('loading');

                if (item_element.children('.container').length > 0) {
                  // item_element.children('.container').remove();
                  // DOES THIS HAVE SOME CONTENT
                  if (item_element.children('.container').contents().length > 0) {
                    // IF YES, CARRY ON, NOTHING TO DO
                    //
                    item_element //.parent('.single_item')
                      .removeClass('loading')
                      .addClass('loaded');
                  }
                }
              });
              // update for the in-view elements
              // lazyload_catalogue();
              $(window).trigger('scroll');
            }
            switch(e.key) {
              case 'Enter':
                $('.proposed_term').remove();
                break;
              case 'Escape':
                console.log(e);
                if ( $('.proposed_term').length > 0 ) {
                  $('.proposed_term').remove();
                } else {
                  $(e.target).val('');
                }

                break;
              default:
                // standard process
            }
        })
        .appendTo(filter_container);
      $('<div>')
        .addClass('clear_input')
        .html('&#10005;')
        .on('click', function(){
          $('.catalogue_filter').val('');
          $('.proposed_term').remove();
          $('div.filter_hide_product')
            .removeClass('filter_hide_product')
            .addClass('loaded');
        })
        .appendTo(filter_container);
    }


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Check to see if there is a contextual menu, remove main menu if so
    if ( $('.nav-contextual').children().length > 0 ) {
      $('.banner>.container>.nav-primary').remove();
    }


    if ( ($('.images_gallery').length > 0) && ($('.images_gallery').find('li').length > 1) ) {
      var $container = $('.images_gallery ul');
      $container.imagesLoaded( function() {
        $container.flickity({
          pageDots: false,
          fullscreen: false,
          cellSelector: 'figure',
          prevNextButtons: true,
          wrapAround: true,
          imagesLoaded: true,
          autoPlay: true,
          arrowShape: 'M84.3,0l-70,50l70,50',
        });  
        
      });
    }



    $( '.nav-full li.menu-item-has-children' ).append( '<button class="expander"><svg class="view-more-arrow" viewBox="0 0 10 14.4"><use xlink:href="#more_arrow"></use></svg></button>' );

    $('button.expander').on('click', function(e){
      e.preventDefault();
      $(this).parent().toggleClass('tapped');
      $(this).toggleClass('tapped');
    });

    if ( !(  $('body').hasClass('home')  )) {
      $('.page-header').prependTo('.banner .container');
      $('.banner .container').addClass('nav-active');
    }

    $('.main').lazy();

    setTimeout(function () {
      $('.banner .container').removeClass('nav-active');
  }, 3500);

  },
};

// Plugins and custom functions
$.fn.isInViewport = function(offset) {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  if (offset) {
    viewportTop = $(window).scrollTop() + offset;
     viewportBottom = viewportTop + $(window).height() + offset ;
  }
  return elementBottom > viewportTop && elementTop < viewportBottom;
};






// WEBPACK FOOTER //
// ./scripts/routes/common.js